import { useMap } from 'react-leaflet';
import { LatLng, LeafletMouseEvent, Map } from 'leaflet';
import { ReactElement, useEffect } from 'react';

(window as any).isDebugMode = true;

export function DebugLogger(): ReactElement {
	const mapReference: Map = useMap();

	function log(latlng: LatLng): void {
		// eslint-disable-next-line no-console
		console.log(latlng);
		navigator.clipboard.writeText(`${latlng.lat},${latlng.lng}`);
	}

	useEffect(() => {
		mapReference.off('click', (e: LeafletMouseEvent) => {
			if ((window as any).isDebugMode) log(e.latlng);
		});
		mapReference.on('click', (e: LeafletMouseEvent) => {
			if ((window as any).isDebugMode) log(e.latlng);
		});
	}, [mapReference, (window as any).isDebugMode]);
	return <></>;
}
